import { appURLs } from "@/app/constants.mjs";
import { getCurrentPatchForStaticData } from "@/game-lol/utils/patches.mjs";
import makeStrictKeysObject from "@/util/strict-keys-object.mjs";

let currentPatch = null as string | null;

function getCurrentPatch() {
  if (!currentPatch) {
    currentPatch = getCurrentPatchForStaticData();
  }
  return currentPatch;
}

const staticMediaURLs = makeStrictKeysObject({
  getChampionKeyFromId(champions, championId) {
    return champions?.keys?.[championId];
  },
  getChampionIdFromKey(champions, championKey) {
    const index = Object.values(champions?.keys)?.indexOf(championKey);
    return Object.keys(champions?.keys)?.[index];
  },
  getChampionNameFromId(champions, championId) {
    const championKey = champions?.keys?.[championId];
    return champions?.[championKey]?.name;
  },
  getChampioNameFromKey(champions, championKey) {
    return champions?.[championKey]?.name;
  },
  getChampionSplashImageById(champions, championId) {
    const key = champions.keys[championId];
    return `${appURLs.CDN}/blitz/centered/${key}_Splash_Centered_0.webp`;
  },
  getRuneImage(runeId) {
    if (!runeId) return null;
    return `${appURLs.CDN}/runes/all/${runeId}.webp?v=${getCurrentPatch()}`;
  },
  getRuneTreeImage(treeKey) {
    if (!treeKey) return null;
    return `${appURLs.CDN}/blitz/ui/img/backdrops/${treeKey}.jpg`;
  },
  getSpellImageById(spells, spellId) {
    const id = Object.keys(spells || {}).find((key) => {
      return Number(spells?.[key]?.key) === spellId;
    });
    return staticMediaURLs.getChampionSpellImageById(id);
  },
  getSummonerSpellImageById(spellId) {
    if (!spellId) return null;
    return `${appURLs.CDN}/blitz/lol/summoner-spells/${spellId}.webp`;
  },
  getChampionSplashImage(key) {
    if (!key) return null;
    return `${appURLs.CDN}/blitz/centered/${key}_Splash_Centered_0.webp`;
  },
  getChampionSpellImageById(id) {
    if (!id) return null;
    return `${appURLs.CDN}/blitz/lol/spell/${id}.webp`;
  },
  getChampionPassiveImageById(passiveId) {
    if (!passiveId) return null;
    return `${appURLs.CDN}/blitz/lol/passive/${passiveId.replace(
      ".png",
      ".webp",
    )}`;
  },
  getItemImage(itemId) {
    if (!itemId) return null;
    return `${appURLs.CDN}/blitz/lol/item/${itemId}.webp?v=${getCurrentPatch()}`;
  },
  getSwarmItemImage(itemId) {
    if (!itemId) return null;
    return `${appURLs.CDN}/blitz/lol/item-swarm/${itemId}.webp?v=${getCurrentPatch()}`;
  },
  getSwarmAugmentImage(augmentId) {
    if (!augmentId) return null;
    return `${appURLs.CDN}/blitz/lol/augment-swarm/${augmentId}.webp`;
  },
  getProfileIcon(iconId = 0) {
    if (!iconId || iconId <= 0) iconId = 26;
    return `${appURLs.CDN}/blitz/lol/profileicon/${iconId}.webp`;
  },
  getChampionImage(key) {
    if (!key) return null;
    return `${appURLs.CDN}/blitz/lol/champion/${key}.webp`;
  },
  getChampionPreReleaseImage(key) {
    if (!key) return null;
    return `${
      appURLs.CDN
    }/blitz/lol/champion_prerelease/${key.toLowerCase()}.webp`;
  },
  getChampionCenterImage(key, small = false) {
    if (!key) return null;
    const suffix = small ? `-small` : "";
    return `${appURLs.CDN}/blitz/lol/champion_centered/${key}${suffix}.webp`;
  },
  getChampionCenterSkinImage(championId, skinId) {
    if (!championId) return null;
    if (!skinId)
      return `${appURLs.CDN}/blitz/lol/champion_centered_splashes/${championId}000.webp`;
    const skin =
      skinId >= 100 ? skinId : skinId >= 10 ? `0${skinId}` : `00${skinId}`;
    return `${appURLs.CDN}/blitz/lol/champion_centered_splashes/${championId}${skin}.webp`;
  },
  getChampionSwarmImage(id, centered) {
    if (!id) return null;
    const key = centered ? `${id}_centered` : `${id}`;
    return `${appURLs.CDN}/blitz/lol/champion_swarm/${key}.jpg`;
  },
  getRankImage(tier, size) {
    const base = `${appURLs.CDN}/ranks/2023`;
    if (!tier || typeof tier !== "string") return `${base}/unranked.webp`;
    if (size === "small") {
      return `${appURLs.CDN}/ranks/2023/60x60/${tier.toLowerCase()}.webp`;
    }
    return `${base}/${tier.toLowerCase()}.webp`;
  },
  getProTeamImage(teamImg) {
    if (!teamImg) return null;
    return `${appURLs.CDN}/probuilds/img/teams/${teamImg}`;
  },
  getArenaAugmentImage(iconPath) {
    if (!iconPath) return null;
    return `${appURLs.CDN}/blitz/lol/arena/augments/${iconPath}`.toLowerCase();
  },
});

export default staticMediaURLs;
